module.exports = __webpack_public_path__ + "img/P150T_weapon_34.a7c5e60e.png";